/* === CLAUDE-SHOPIFY-CHANGE-018-START | Sonsuz kaydırma v2: erken tetikleme (rootMargin), filtre sonrası yeniden bağlanma, disabled iken tekrar tıklamama (2026-09-22) === */
/* Orijinal (Sahara):
 *   const viewMoreElement = document.querySelector('.js-btn-load-more');
 *   if (viewMoreElement) { new IntersectionObserver(entries => entries.forEach(e => { if (e.isIntersecting) viewMoreElement.click(); })).observe(viewMoreElement); }
 */
(() => {
  let observedButton = null;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const button = entry.target;
        const container = button.closest('collection-load-more');

        if (button.disabled || (container && container.classList.contains('hidden'))) return;

        button.click();
      });
    },
    { rootMargin: '900px 0px 900px 0px' }
  );

  const attach = () => {
    const button = document.querySelector('.js-btn-load-more');

    if (!button || button === observedButton) return;

    if (observedButton) observer.unobserve(observedButton);

    observedButton = button;
    observer.observe(button);
  };

  attach();

  // Filtre/sıralama sonrası facets.js #ProductGridContainer'ı yeniden yazar -> yeni butona bağlan
  new MutationObserver(attach).observe(document.body, { childList: true, subtree: true });

  window.addEventListener('shopify:section:load', attach);
})();
/* === CLAUDE-SHOPIFY-CHANGE-018-END === */
